import { render } from "./stronaKontaUstawienia.vue?vue&type=template&id=d65d608e&scoped=true"
import script from "./stronaKontaUstawienia.vue?vue&type=script&lang=js"
export * from "./stronaKontaUstawienia.vue?vue&type=script&lang=js"

import "./stronaKontaUstawienia.vue?vue&type=style&index=0&id=d65d608e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d65d608e"]])

export default __exports__